// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { InvoicesDataViewContext } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageTitleCount from "@sc/App/Components/Common/PageTitleCount";
import React, { FC, useContext } from "react";

const SavedOrdersTitleCount: FC<WidgetProps> = () => {
    const invoicesDataView = useContext(InvoicesDataViewContext);

    const invoicesCount =
        invoicesDataView.value && invoicesDataView.pagination ? invoicesDataView.pagination.totalItemCount : 0;

    return <PageTitleCount countNumber={invoicesCount} countName="Invoice" />;
};

const widgetModule: WidgetModule = {
    component: SavedOrdersTitleCount,
    definition: {
        group: "Invoice History",
        displayName: "Invoice History Title Count",
        allowedContexts: ["InvoiceHistoryPage"],
    },
};

export default widgetModule;
